var _defs, _path, _path2, _line, _line2, _path3, _path4, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFiesta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.92 79.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#5656ff;stroke-linecap:round;stroke-linejoin:round;stroke-width:2.19px;}.cls-2{fill:#5656ff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M51,23.5H77.42a0,0,0,0,1,0,0V47.17A13.23,13.23,0,0,1,64.19,60.4h0A13.23,13.23,0,0,1,51,47.17V23.5A0,0,0,0,1,51,23.5Z",
    transform: "translate(-9.51 20.78) rotate(-17.14)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.45,59.58h0a13.22,13.22,0,0,1-16.54-8.74L49.19,38.78l27.12-1.85L78.2,43A13.23,13.23,0,0,1,69.45,59.58Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 70.19,
    y1: 59.4,
    x2: 73.94,
    y2: 69.91
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 66.77,
    y1: 72.42,
    x2: 81.3,
    y2: 67.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.8,23.5h0A13.23,13.23,0,0,1,40,36.73V60.4a0,0,0,0,1,0,0H13.57a0,0,0,0,1,0,0V36.73A13.23,13.23,0,0,1,26.8,23.5Z",
    transform: "translate(40.05 89.94) rotate(-162.86)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.54,59.58h0a13.22,13.22,0,0,0,16.54-8.74L41.8,38.78,14.68,36.93,12.79,43A13.24,13.24,0,0,0,21.54,59.58Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 20.81,
    y1: 59.4,
    x2: 17.05,
    y2: 69.91
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.22,
    y1: 72.42,
    x2: 9.69,
    y2: 67.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFiesta);
export default __webpack_public_path__ + "static/media/Icon-fiesta.0a44551963ec8e01048e0ec514d93cea.svg";
export { ForwardRef as ReactComponent };